import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { withRouter } from 'react-router-dom';

import { Card, CardBody, Input, Label, Spinner } from 'reactstrap';

import { connect } from 'react-redux';

import {
  getComplianceData,
  updateComplianceData,
} from '../../../../actions/company';

const pound = `${'\u00A3'}`;

class Compliance extends Component {
  static propTypes = {
    user: PropTypes.shape(),
    categories: PropTypes.shape(),
    company: PropTypes.shape(),
    updateCompanyValue: PropTypes.func.isRequired,
    updateLogo: PropTypes.func.isRequired,
    updatePrimaryVoucherImage: PropTypes.func.isRequired,
    updateVoucherImages: PropTypes.func.isRequired,
    getCompliance: PropTypes.func.isRequired,
    updateCompliance: PropTypes.func.isRequired,
  };

  static defaultProps = {
    user: {},
    categories: {},
    company: {},
  };

  constructor(props) {
    super(props);
    this.state = {
      error: null,
      loading: false,
      companyLogo: null,
      companyPrimaryVoucherImage: null,
      existingVoucherImages: [],
      deletedExistingImages: [],
      changes: {},
      complianceData: {},
      showNoPermission: false,
      categoriesOrdered: [],
    };
  }

  componentDidMount() {
    const { user, isLoggedIn, history, adminViewAsCompany, categories, getCompliance } = this.props;

    if (adminViewAsCompany) {
      this.setState({ showNoPermission: false });

      getCompliance(adminViewAsCompany).then((res) => {
        this.setState({ complianceData: res });
      });
    } else if (user && Object.keys(user).length > 0) {

      if (!user || !isLoggedIn || !user.company) {
        history.push('/');
      } else {
        getCompliance(user.company).then((res) => {
          this.setState({ complianceData: res });
        });

        if (user.role === 'teamOwner') {
          this.setState({ showNoPermission: false });
        } else {
          const { roles } = this.props;

          if (roles && roles[user.role] && roles[user.role].permissions && roles[user.role].permissions.manageCompany) {
            this.setState({ showNoPermission: false });
          } else {
            this.setState({ showNoPermission: true });
          }
        }
      }
    } else {
      history.push('/');
    }
  }


  handleChange = async (e) => {
    if (e.target && e.target.name) {
      const { name, value } = e.target;

      console.log('handleChange', name, value);

      if (name) {
        if (name === 'hasDisplayName') {
          const { checked } = e.target;

          this.setState((prevState) => ({
            changes: {
              ...prevState.changes,
              [name]: checked || false,
            },
          }));
          return null;
        } else if (name === 'description' && value.length > 500) {
          return null;
        } else {

          await this.setState((prevState) => ({
            changes: {
              ...prevState.changes,
              [name]: value || '',
            },
          }));

          if (name === 'category1' || name === 'category2') {
            this.saveChange(e, name);
          }
        }
      }
    }
  };

  closeChange = (e, id) => {
    e.stopPropagation();
    console.log('reset changes 2', id);

    if (id === 'companyNumber') {
      this.setState((prevState) => ({
        changes: {
          ...prevState.changes,
          [id]: null,
          companyType: null,
        },
        error: null,
        success: null,
      }));
    } else {
      this.setState((prevState) => ({
        changes: {
          ...prevState.changes,
          [id]: null,
        },
        error: null,
        success: null,
      }));
    }
  }


  updateComplianceData = async (e, clickedType) => {
    if (e.target && e.target.name) {
      const { name, value } = e.target;

      if (this.state[`typingTimeout${name}`]) {
        clearTimeout(this.state[`typingTimeout${name}`]);
      }

      let timeoutTime = 400;

      if (name === 'question1Description' || name === 'question2Description' || name === 'question3Description' || name === 'question5Description') {
        timeoutTime = 1700;
      }

      if (name === 'question1' || name === 'question2' || name === 'question3') {
        let checked = true;
        if (clickedType === 'no') {
          checked = false;
        }

        await this.setState((prevState) => ({
          complianceData: {
            ...prevState.complianceData,
            [name]: checked || false,
          },
        }));
      } else {
        await this.setState((prevState) => ({
          complianceData: {
            ...prevState.complianceData,
            [name]: value || '',
          },
        }));
      }

      this.setState({
        [`typingTimeout${name}`]: setTimeout(() => {
          this.saveComplianceData(name);
        }, timeoutTime)
      });
    }
  }

  saveComplianceData = (name) => {
    const { user, updateCompliance, adminViewAsCompany, savingComplianceData } = this.props;
    const { complianceData } = this.state;

    if (adminViewAsCompany) {
      //  updateCompliance(complianceData, adminViewAsCompany);
    } else {
      if (!savingComplianceData) {
        this.setState({ savingComplianceData: name });

        updateCompliance(name, complianceData[name], user.company).then(() => {
          this.setState({ savingComplianceData: null });
        }).catch(err => {
          this.setState({ savingComplianceData: null });
        });
      }
    }
  }

  render() {
    const { company, adminViewAsCompany, showNoPermission } = this.props;
    const {
      changes,
      buttonPressed,
      complianceData,
      savingComplianceData,
    } = this.state;

    return (
      <div>
        <Card style={{ borderRadius: 20 }}>
          <CardBody style={{ paddingTop: 11 }}>
            <div class="basic-information" style={{ padding: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0 }}>
              <div className="basic-information-row">
                <Label style={{ fontWeight: 700, color: "#000" }}>Compliance questions</Label>
              </div>
              <div className="basic-information-row" style={{ marginBottom: 15, fontSize: 14 }}>
                These answers will not be shared externally without your consent. If the status of the below changes, please update these immediately.
              </div>
              <div className="basic-information-row">
                <div className="basic-information-compliance-label basic-information-compliance-label-1">
                  Have you been trading for the past 12 months?
                  {savingComplianceData === 'question1' ? (
                    <Spinner animation="border" variant="primary" style={{ width: '1.3rem', height: '1.3rem', marginTop: 3 }}> {''} </Spinner>
                  ) : (null)}
                </div>
                <div className="basic-information-compliance-right basic-information-compliance-right-1">
                  <div style={{ width: 35, float: 'right' }}>
                    <Label style={{ paddingRight: '0.4rem', display: 'block', float: 'right', width: 35 }} for="question1"> No </Label>
                  </div>
                  <div style={{ width: 18, float: 'right' }}>
                    <Input
                      style={{ marginLeft: 15, width: 18, height: 18, position: 'relative', display: 'block', float: 'right' }}
                      name="question1"
                      disabled={savingComplianceData === 'question1' || showNoPermission || adminViewAsCompany}
                      type="radio"
                      checked={complianceData && complianceData.question1 === false}
                      onChange={(e) => this.updateComplianceData(e, 'no')}
                    />
                  </div>

                  <div style={{ width: 35, float: 'right' }}>
                    <Label style={{ paddingRight: '0.4rem', display: 'block', float: 'right', width: 35 }} for="question1"> Yes </Label>
                  </div>
                  <div style={{ width: 18, float: 'right' }}>
                    <Input
                      style={{ marginLeft: 15, width: 18, height: 18, position: 'relative', display: 'block', float: 'right' }}
                      name="question1"
                      disabled={savingComplianceData === 'question1' || showNoPermission || adminViewAsCompany}
                      type="radio"
                      checked={complianceData && complianceData.question1}
                      onChange={(e) => this.updateComplianceData(e, 'yes')}
                    />
                  </div>

                  {complianceData && complianceData.question1 === false ? (
                    <div style={{ marginLeft: 106 }}>
                      <Input
                        style={{ marginLeft: 0, width: '100%', minWidth: 130, minHeight: 38, height: 38, position: 'relative', display: 'inline-block' }}
                        name="question1Description"
                        disabled={savingComplianceData === 'question1Description' || showNoPermission || adminViewAsCompany}
                        placeholder="Brief explanation..."
                        type="textarea"
                        value={complianceData && complianceData.question1Description}
                        onChange={this.updateComplianceData}
                      />
                    </div>
                  ) : (null)}
                </div>
              </div>
              <div className="basic-information-row">
                <div className="basic-information-compliance-label basic-information-compliance-label-2">
                  Are you solvent, able and intending to continue trading for the foreseeable future?
                  {savingComplianceData === 'question2' ? (
                    <Spinner animation="border" variant="primary" style={{ width: '1.3rem', height: '1.3rem', marginTop: 3 }}> {''} </Spinner>
                  ) : (null)}
                </div>
                <div className="basic-information-compliance-right basic-information-compliance-right-2">

                  <div style={{ width: 35, float: 'right' }}>
                    <Label style={{ paddingRight: '0.4rem', display: 'block', float: 'right' }} for="question2"> No </Label>
                  </div>
                  <div style={{ width: 18, float: 'right' }}>
                    <Input
                      style={{ marginLeft: 15, width: 18, height: 18, position: 'relative', display: 'block', float: 'right' }}
                      name="question2"
                      disabled={savingComplianceData === 'question2' || showNoPermission || adminViewAsCompany}
                      type="radio"
                      checked={complianceData && complianceData.question2 === false}
                      onChange={(e) => this.updateComplianceData(e, 'no')}
                    />
                  </div>

                  <div style={{ width: 35, float: 'right' }}>
                    <Label style={{ paddingRight: '0.4rem', display: 'block', float: 'right' }} for="question2"> Yes </Label>
                  </div>
                  <div style={{ width: 18, float: 'right' }}>
                    <Input
                      style={{ marginLeft: 15, width: 18, height: 18, position: 'relative', display: 'block', float: 'right' }}
                      name="question2"
                      disabled={savingComplianceData === 'question2' || showNoPermission || adminViewAsCompany}
                      type="radio"
                      checked={complianceData && complianceData.question2}
                      onChange={(e) => this.updateComplianceData(e, 'yes')}
                    />
                  </div>

                  {complianceData && complianceData.question2 === false ? (
                    <div style={{ marginLeft: 106 }}>
                      <Input
                        style={{ marginLeft: 0, width: '100%', minWidth: 130, minHeight: 38, height: 38, position: 'relative', display: 'inline-block' }}
                        name="question2Description"
                        disabled={savingComplianceData === 'question2Description' || showNoPermission || adminViewAsCompany}
                        placeholder="Brief explanation..."
                        type="textarea"
                        value={complianceData && complianceData.question2Description}
                        onChange={this.updateComplianceData}
                      />
                    </div>
                  ) : (null)}
                </div>
              </div>

              <div className="basic-information-row">
                <div className="basic-information-compliance-label basic-information-compliance-label-3">
                  Have you had any issues with lenders/creditors/HMRC over the past 12 months?
                  {savingComplianceData === 'question3' ? (
                    <Spinner animation="border" variant="primary" style={{ width: '1.3rem', height: '1.3rem', marginTop: 3 }}> {''} </Spinner>
                  ) : (null)}
                </div>
                <div className="basic-information-compliance-right basic-information-compliance-right-3">
                  <div style={{ width: 35, float: 'right' }}>
                    <Label style={{ paddingRight: '0.4rem', display: 'block', float: 'right' }} for="question3"> No </Label>
                  </div>
                  <div style={{ width: 18, float: 'right' }}>
                    <Input
                      style={{ marginLeft: 15, width: 18, height: 18, position: 'relative', display: 'block', float: 'right' }}
                      name="question3"
                      disabled={savingComplianceData === 'question3' || showNoPermission || adminViewAsCompany}
                      type="radio"
                      checked={complianceData && complianceData.question3 === false}
                      onChange={(e) => this.updateComplianceData(e, 'no')}
                    />
                  </div>

                  <div style={{ width: 35, float: 'right' }}>
                    <Label style={{ paddingRight: '0.4rem', display: 'block', float: 'right' }} for="question3"> Yes </Label>
                  </div>
                  <div style={{ width: 18, float: 'right' }}>
                    <Input
                      style={{ marginLeft: 15, width: 18, height: 18, position: 'relative', display: 'block', float: 'right' }}
                      name="question3"
                      disabled={savingComplianceData === 'question3' || showNoPermission || adminViewAsCompany}
                      type="radio"
                      checked={complianceData && complianceData.question3}
                      onChange={(e) => this.updateComplianceData(e, 'yes')}
                    />
                  </div>


                  {complianceData && complianceData.question3 === true ? (
                    <div style={{ marginLeft: 106 }}>
                      <Input
                        style={{ marginLeft: 0, width: '100%', minWidth: 130, minHeight: 38, height: 38, position: 'relative', display: 'inline-block' }}
                        name="question3Description"
                        disabled={savingComplianceData === 'question3Description' || showNoPermission || adminViewAsCompany}
                        placeholder="Brief explanation..."
                        type="textarea"
                        value={complianceData && complianceData.question3Description}
                        onChange={this.updateComplianceData}
                      />
                    </div>
                  ) : (null)}
                </div>
              </div>

              <div className="basic-information-row">
                <div className="basic-information-compliance-label basic-information-compliance-label-4">
                  What was your turnover bracket for the last 12 months?
                  {savingComplianceData === 'question4' ? (
                    <Spinner animation="border" variant="primary" style={{ width: '1.3rem', height: '1.3rem', marginTop: 3 }}> {''} </Spinner>
                  ) : (null)}
                </div>
                <div className="basic-information-compliance-right basic-information-compliance-right-4">
                  <Input
                    style={{ width: '100%', minWidth: 155, maxWidth: 190, paddingLeft: 22, paddingRight: 22, float: 'right', marginRight: 5 }}
                    name="question4"
                    type="select"
                    className="form-control" value={complianceData && complianceData.question4}
                    onChange={this.updateComplianceData}
                    disabled={savingComplianceData === 'question4' || showNoPermission || adminViewAsCompany}
                    className={(!complianceData || !complianceData.question4) ? "basic-information-placeholder" : ''}
                  >
                    <option value={null} hidden selected> Select </option>
                    <option value={1}> {`${pound}0-${pound}25,000`} </option>
                    <option value={2}> {`${pound}25,001-${pound}50,000`} </option>
                    <option value={3}> {`${pound}50,001-${pound}100,000`} </option>
                    <option value={4}> {`${pound}100,001-${pound}250,000`} </option>
                    <option value={5}> {`${pound}250,001-${pound}500,000`} </option>
                    <option value={6}> {`${pound}500,001-${pound}1,000,000`} </option>
                    <option value={7}> {`${pound}1,000,001-${pound}5,000,000`} </option>
                    <option value={8}> {`${pound}5,000,001+`} </option>
                  </Input>
                </div>
              </div>

              <div className="basic-information-row">
                <div className="basic-information-compliance-label basic-information-compliance-label-5">
                  What was your net income bracket for the last 12 months?
                  {savingComplianceData === 'question5' ? (
                    <Spinner animation="border" variant="primary" style={{ width: '1.3rem', height: '1.3rem', marginTop: 3 }}> {''} </Spinner>
                  ) : (null)}
                </div>
                {console.log('complianceData test', complianceData)}
                <div className="basic-information-compliance-right basic-information-compliance-right-5">
                  <Input
                    style={{ width: '100%', minWidth: 155, maxWidth: 190, paddingLeft: 22, paddingRight: 22, float: 'right', marginRight: 5 }}
                    name="question5"
                    type="select"
                    className="form-control"
                    value={complianceData && complianceData.question5}
                    onChange={this.updateComplianceData}
                    disabled={savingComplianceData === 'question5' || showNoPermission || adminViewAsCompany}
                    className={(!complianceData || !complianceData.question5) ? "basic-information-placeholder" : ''}
                  >
                    <option value={null} hidden selected> Select </option>
                    <option value={1}> {`<${pound}0`} </option>
                    <option value={2}> {`${pound}0-${pound}25,000`} </option>
                    <option value={3}> {`${pound}25,001-${pound}50,000`} </option>
                    <option value={4}> {`${pound}50,001-${pound}100,000`} </option>
                    <option value={5}> {`${pound}100,001-${pound}250,000`} </option>
                    <option value={6}> {`${pound}250,001-${pound}500,000`} </option>
                    <option value={7}> {`${pound}500,001-${pound}1,000,000`} </option>
                    <option value={8}> {`${pound}1,000,001-${pound}5,000,000`} </option>
                    <option value={9}> {`${pound}5,000,001+`} </option>
                  </Input>
                  {complianceData && complianceData.question5 === '1' ? (
                    <Input
                      style={{ marginTop: 10, marginLeft: 0, width: 'auto', minWidth: 200, minHeight: 38, height: 38, position: 'relative', display: 'inline-block' }}
                      name="question5Description"
                      disabled={savingComplianceData === 'question5' || showNoPermission || adminViewAsCompany}
                      placeholder="Brief explanation..."
                      type="textarea"
                      value={complianceData && complianceData.question5Description}
                      onChange={this.updateComplianceData}
                    />
                  ) : (null)}
                </div>
              </div>
            </div>

          </CardBody>
        </Card>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user.userData || {},
  company: state.company.company || {},
  isLoggedIn: state.user.isLoggedIn || false,
  adminViewAsCompany: state.admin.adminViewAsCompany || null,
  roles: state.users.companiesRoles || {},
});

const mapDispatchToProps = {
  getCompliance: getComplianceData,
  updateCompliance: updateComplianceData,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Compliance));
